import { DisplayItem } from 'design-system';

/**
 * Unified source for the gender options
 */
const relationships: DisplayItem[] = [
  { Value: '0000', Text: 'Desconocido' },
  { Value: '0001', Text: 'Titular Masculino' },
  { Value: '0002', Text: 'Titular Femenino' },
  { Value: '0003', Text: 'Esposo' },
  { Value: '0004', Text: 'Esposa' },
  { Value: '0005', Text: 'Hijo' },
  { Value: '0006', Text: 'Hija' },
  { Value: '0007', Text: 'Abuelo' },
  { Value: '0008', Text: 'Abuela' },
  { Value: '0009', Text: 'Tío' },

  { Value: '0010', Text: 'Tía' },
  { Value: '0011', Text: 'Hermana' },
  { Value: '0012', Text: 'Hermano' },
  { Value: '0013', Text: 'Madre' },
  { Value: '0014', Text: 'Padre' },
  { Value: '0015', Text: 'Cuñado' },
  { Value: '0016', Text: 'Cuñada' },
  { Value: '0017', Text: 'Suegro' },
  { Value: '0018', Text: 'Suegra' },
  { Value: '0019', Text: 'Amigo' },

  { Value: '0020', Text: 'Acreedor' },
  { Value: '0021', Text: 'Amiga' },
  { Value: '0022', Text: 'Ahijado' },
  { Value: '0023', Text: 'Ahijada' },
  { Value: '0024', Text: 'Administrador' },
  { Value: '0026', Text: 'Empresa' },
  { Value: '0027', Text: 'Fundación' },
  { Value: '0028', Text: 'Sobrino' },
  { Value: '0029', Text: 'Sobrina' },

  { Value: '0030', Text: 'Fideicomiso' },
  { Value: '0031', Text: 'Nieto' },
  { Value: '0032', Text: 'Nieta' },
  { Value: '0033', Text: 'Primo' },
  { Value: '0034', Text: 'Prima' },
  { Value: '0035', Text: 'Empresa 7' },
  { Value: '0036', Text: 'El mismo titular' },
  { Value: '0037', Text: 'Ex-esposa' },
  { Value: '0038', Text: 'Ex-esposo' },
  { Value: '0039', Text: 'Compadre' },

  { Value: '0040', Text: 'Comadre' },
  { Value: '0041', Text: 'Padrino' },
  { Value: '0042', Text: 'Madrina' },
  { Value: '0043', Text: 'Hijastro' },
  { Value: '0044', Text: 'Hijastra' },
  { Value: '0045', Text: 'Padrastro' },
  { Value: '0046', Text: 'Madrastra' },
  { Value: '0047', Text: 'Nuera' },
  { Value: '0048', Text: 'Yerno' },
  { Value: '0049', Text: 'Compañero' },

  { Value: '0050', Text: 'Compañera' },
  { Value: '0051', Text: 'Nana' },
  { Value: '0052', Text: 'Socio' },
  { Value: '0053', Text: 'Novia' },
  { Value: '0054', Text: 'Novio' },
  { Value: '0055', Text: 'Prometida' },
  { Value: '0056', Text: 'Prometid0' },
  { Value: '0057', Text: 'Empresa 6' },
  { Value: '0058', Text: 'Segun Anexo' },
  { Value: '0059', Text: 'Herederos Legales' },

  { Value: '0060', Text: 'Dueño' },
  { Value: '0061', Text: 'Patrono' },
  { Value: '0062', Text: 'Contratante' },
  { Value: '0063', Text: 'Empresa 8' },
  { Value: '0064', Text: 'Arrendatario' },
];

export default relationships;
